import mime from 'mime-types';

function urlToPathname(url: string): string | null {
    try {
        return new URL(url).pathname;
    } catch (e) {
        console.error(e, url);
    }
    return null;
}

interface FileData {
    url?: string;
    file?: File | null;
    mimetype?: string;
}

export const getFileExtension = ({
    url, file, mimetype}: FileData): string | null => {
    let mediaType: string | null = null;
    if (url) {
        const path = urlToPathname(url);
        mimetype = mime.lookup(path) || null;
    } else if (file) {
        if (file.type) {
            // `type` is present on `Blob`.
            mimetype = file.type;
        } else {
            mimetype = mime.lookup(file.name) || null;
        }
    }

    if (mimetype) {
        mediaType = mime.extension(mimetype) || null;
    }
    return mediaType;
};

export const getFilename = ({url, file}: FileData): string | null => {
    let filename: string | null = null;
    if (url) {
        const path = urlToPathname(url);
        if (path) {
            filename = path.split('/').slice(-1)[0];
        }
    } else if (file?.name) {
        filename = file.name.toLowerCase();
    }
    return filename;
};

export const isValidFileType = (
    dataObject: FileData, allowedFileTypes: string[]): boolean => {
    const mediaType = getFileExtension(dataObject);
    return allowedFileTypes.includes(mediaType || '');
};

export const getMimeType = (fileType: string): string | null => {
    return mime.lookup(fileType) || null;
};
